import axiosPrivate from "./axiosPrivate";

const getPagos = (params) => {
    return axiosPrivate.get("finanzas-pagos", { params })
        .then(response => response.data);
};

const insertPago = (data) => {
    return axiosPrivate.post("finanzas-pagos", data)
        .then(response => response.data);
};

const updatePago = (data) => {
    return axiosPrivate.put("finanzas-pagos", data)
        .then(response => response.data);
};

const deletePago = (data) => {
    return axiosPrivate.delete("finanzas-pagos", { data })
        .then(response => response.data);
};

export default {
    getPagos,
    insertPago,
    updatePago,
    deletePago
};